import moment, { Moment } from 'moment'
import React, { useContext } from 'react'
import styled from 'styled-components'

import BodyText from 'components/Luxkit/Typography/BodyText'
import { SHORT_DAY_NAME_DAY_MONTH_YEAR } from 'constants/dateFormats'
import { useRegionTimeFormat } from 'hooks/useRegionTimeFormat'
import TripContext, { TripContextValue } from 'tripPlanner/contexts/TripContext'

interface Props {
  startDate: Moment | undefined
  endDate: Moment | undefined
  startDay?: number
  endDay?: number
  startTime: Moment | undefined
  endTime: Moment | undefined
  isAccommodation: boolean
}

const Dates = styled.div`
  display: flex;
  width: 100%;
`

const Date = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

function CheckInAndOutDate({
  startDate,
  endDate,
  startDay,
  endDay,
  startTime,
  endTime,
  isAccommodation,
}: Props) {
  const timeFormat = useRegionTimeFormat()
  const tripContext = useContext<TripContextValue | null>(TripContext)

  return (
    <Dates>
      {startDate && moment(startDate).isValid() && (
        <Date>
          <BodyText variant="medium" weight="bold">
            {isAccommodation ? 'Check in' : 'Start date'}
          </BodyText>
          <BodyText variant="large">
            {tripContext?.viewAsTemplate && startDay ?
              startDay :
              startDate.format(SHORT_DAY_NAME_DAY_MONTH_YEAR)}
          </BodyText>
          {startTime && (
            <BodyText variant="large">{startTime.format(timeFormat)}</BodyText>
          )}
        </Date>
      )}
      {endDate && moment(endDate).isValid() && (
        <Date>
          <BodyText variant="medium" weight="bold">
            {isAccommodation ? 'Check out' : 'End date'}
          </BodyText>
          <BodyText variant="large">
            {tripContext?.viewAsTemplate && endDay ?
              endDay :
              endDate.format(SHORT_DAY_NAME_DAY_MONTH_YEAR)}
          </BodyText>
          {endTime && (
            <BodyText variant="large">{endTime.format(timeFormat)}</BodyText>
          )}
        </Date>
      )}
    </Dates>
  )
}

export default CheckInAndOutDate
